import ValueSelect from './component'

export default ValueSelect
